module.exports = __webpack_public_path__ + "img/logo02.284c66b8.png";